import type { DifferenceOptions } from "./DifferenceOptions";
import dateTime from "./dateTime";

export default function differenceInMonths(
  dateLeft: Date,
  dateRight: Date,
  options?: DifferenceOptions,
) {
  return dateTime(dateLeft).difference(dateTime(dateRight), "months", options);
}
